import { render } from "./StatisticsPortalEventsUsersTable.vue?vue&type=template&id=47ff09e1&scoped=true&ts=true"
import script from "./StatisticsPortalEventsUsersTable.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalEventsUsersTable.vue?vue&type=script&lang=ts"

import "./StatisticsPortalEventsUsersTable.vue?vue&type=style&index=0&id=47ff09e1&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ff09e1"]])

export default __exports__